var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('p',{staticClass:"font-weight-black display-4"},[_vm._v("URL Not Found")]),_c('v-btn',{attrs:{"outlined":""},on:{"click":_vm.returnHome}},[_vm._v("Return")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }